//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import leftJobList from "@/components/management/job/leftJobList";
import rightList from "@/components/management/job/rightList";
import addJobDialog from "@/components/management/job/addJobDialog";
import { getJobInfo } from "@/api/managementCenter/jobManage";
import * as serve from "@/api/importAndExport/excelApi";
import importExcel from "@/components/dialog/deptManage/importExcel.vue";
export default {
  name: "Job",
  components: {
    leftJobList: leftJobList,
    addJobDialog: addJobDialog,
    rightList: rightList,
    importExcel: importExcel
  },
  props: [],
  data: function data() {
    return {
      addDialogShow: false,
      uplodData: {
        state: false,
        type: ""
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    openDetailFn: function openDetailFn(item) {
      var _this = this;

      this.loading = true;
      getJobInfo(item.postId).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.$refs.addJobDialogRef.dialogShow("edit", data.data || {});
        } else {
          _this.$message.warning(data.msg || "获取岗位信息失败！");
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    selectJob: function selectJob(item) {
      this.$refs.rightList.loadListFn(item.postId);
    },
    openAddDialog: function openAddDialog() {
      this.$refs.addJobDialogRef.dialogShow("add");
    },
    saveSuccess: function saveSuccess() {
      this.$refs.leftJobList.getJobListFn();
    },
    exportJobFn: function exportJobFn() {
      this.downloadFn(serve.excelExport("userpost"));
    },
    importJobFn: function importJobFn() {
      this.uplodData.state = true;
      this.uplodData.type = "userpost";
    },
    downloadTemplate: function downloadTemplate() {
      this.downloadFn(serve.downloadTemplate("userpost"));
    },
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
    },
    downloadFn: function downloadFn(url) {
      var _this2 = this;

      console.log(url, "uri");
      this.$DownLoad(url, null, function (res) {
        if (res.status == 200) {} else {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  },
  watch: {},
  filters: {}
};